// Generated from CLDR timezone location names; values are display-only.
export const localizedTimezoneNames = {
    "Africa/Abidjan": { "zh-Hant": "象牙海岸", "zh-Hans": "科特迪瓦" },
    "Africa/Accra": { "zh-Hant": "迦納", "zh-Hans": "加纳" },
    "Africa/Addis_Ababa": { "zh-Hant": "衣索比亞", "zh-Hans": "埃塞俄比亚" },
    "Africa/Algiers": { "zh-Hant": "阿爾及利亞", "zh-Hans": "阿尔及利亚" },
    "Africa/Asmara": { "zh-Hant": "厄利垂亞", "zh-Hans": "厄立特里亚" },
    "Africa/Bamako": { "zh-Hant": "馬利", "zh-Hans": "马里" },
    "Africa/Bangui": { "zh-Hant": "中非共和國", "zh-Hans": "中非共和国" },
    "Africa/Banjul": { "zh-Hant": "甘比亞", "zh-Hans": "冈比亚" },
    "Africa/Bissau": { "zh-Hant": "幾內亞比索", "zh-Hans": "几内亚比绍" },
    "Africa/Blantyre": { "zh-Hant": "馬拉威", "zh-Hans": "马拉维" },
    "Africa/Brazzaville": { "zh-Hant": "剛果（布拉薩）", "zh-Hans": "刚果（布）" },
    "Africa/Bujumbura": { "zh-Hant": "蒲隆地", "zh-Hans": "布隆迪" },
    "Africa/Cairo": { "zh-Hant": "埃及", "zh-Hans": "埃及" },
    "Africa/Casablanca": { "zh-Hant": "摩洛哥", "zh-Hans": "摩洛哥" },
    "Africa/Ceuta": { "zh-Hant": "西班牙（休達）", "zh-Hans": "西班牙（休达）" },
    "Africa/Conakry": { "zh-Hant": "幾內亞", "zh-Hans": "几内亚" },
    "Africa/Dakar": { "zh-Hant": "塞內加爾", "zh-Hans": "塞内加尔" },
    "Africa/Dar_es_Salaam": { "zh-Hant": "坦尚尼亞", "zh-Hans": "坦桑尼亚" },
    "Africa/Djibouti": { "zh-Hant": "吉布地", "zh-Hans": "吉布提" },
    "Africa/Douala": { "zh-Hant": "喀麥隆", "zh-Hans": "喀麦隆" },
    "Africa/El_Aaiun": { "zh-Hant": "西撒哈拉", "zh-Hans": "西撒哈拉" },
    "Africa/Freetown": { "zh-Hant": "獅子山", "zh-Hans": "塞拉利昂" },
    "Africa/Gaborone": { "zh-Hant": "波札那", "zh-Hans": "博茨瓦纳" },
    "Africa/Harare": { "zh-Hant": "辛巴威", "zh-Hans": "津巴布韦" },
    "Africa/Johannesburg": { "zh-Hant": "南非", "zh-Hans": "南非" },
    "Africa/Juba": { "zh-Hant": "南蘇丹", "zh-Hans": "南苏丹" },
    "Africa/Kampala": { "zh-Hant": "烏干達", "zh-Hans": "乌干达" },
    "Africa/Khartoum": { "zh-Hant": "蘇丹", "zh-Hans": "苏丹" },
    "Africa/Kigali": { "zh-Hant": "盧安達", "zh-Hans": "卢旺达" },
    "Africa/Kinshasa": { "zh-Hant": "剛果（金夏沙）（金夏沙）", "zh-Hans": "刚果（金）（金沙萨）" },
    "Africa/Lagos": { "zh-Hant": "奈及利亞", "zh-Hans": "尼日利亚" },
    "Africa/Libreville": { "zh-Hant": "加彭", "zh-Hans": "加蓬" },
    "Africa/Lome": { "zh-Hant": "多哥", "zh-Hans": "多哥" },
    "Africa/Luanda": { "zh-Hant": "安哥拉", "zh-Hans": "安哥拉" },
    "Africa/Lubumbashi": { "zh-Hant": "剛果（金夏沙）（盧本巴希）", "zh-Hans": "刚果（金）（卢本巴希）" },
    "Africa/Lusaka": { "zh-Hant": "尚比亞", "zh-Hans": "赞比亚" },
    "Africa/Malabo": { "zh-Hant": "赤道幾內亞", "zh-Hans": "赤道几内亚" },
    "Africa/Maputo": { "zh-Hant": "莫三比克", "zh-Hans": "莫桑比克" },
    "Africa/Maseru": { "zh-Hant": "賴索托", "zh-Hans": "莱索托" },
    "Africa/Mbabane": { "zh-Hant": "史瓦帝尼", "zh-Hans": "斯威士兰" },
    "Africa/Mogadishu": { "zh-Hant": "索馬利亞", "zh-Hans": "索马里" },
    "Africa/Monrovia": { "zh-Hant": "賴比瑞亞", "zh-Hans": "利比里亚" },
    "Africa/Nairobi": { "zh-Hant": "肯亞", "zh-Hans": "肯尼亚" },
    "Africa/Ndjamena": { "zh-Hant": "查德", "zh-Hans": "乍得" },
    "Africa/Niamey": { "zh-Hant": "尼日", "zh-Hans": "尼日尔" },
    "Africa/Nouakchott": { "zh-Hant": "茅利塔尼亞", "zh-Hans": "毛里塔尼亚" },
    "Africa/Ouagadougou": { "zh-Hant": "布吉納法索", "zh-Hans": "布基纳法索" },
    "Africa/Porto-Novo": { "zh-Hant": "貝南", "zh-Hans": "贝宁" },
    "Africa/Sao_Tome": { "zh-Hant": "聖多美普林西比", "zh-Hans": "圣多美和普林西比" },
    "Africa/Timbuktu": { "zh-Hant": "馬利", "zh-Hans": "马里" },
    "Africa/Tripoli": { "zh-Hant": "利比亞", "zh-Hans": "利比亚" },
    "Africa/Tunis": { "zh-Hant": "突尼西亞", "zh-Hans": "突尼斯" },
    "Africa/Windhoek": { "zh-Hant": "納米比亞", "zh-Hans": "纳米比亚" },
    "America/Adak": { "zh-Hant": "美國（艾達克）", "zh-Hans": "美国（埃达克）" },
    "America/Anchorage": { "zh-Hant": "美國（安克拉治）", "zh-Hans": "美国（安克雷奇）" },
    "America/Anguilla": { "zh-Hant": "安奎拉", "zh-Hans": "安圭拉" },
    "America/Antigua": { "zh-Hant": "安地卡及巴布達", "zh-Hans": "安提瓜和巴布达" },
    "America/Araguaina": { "zh-Hant": "巴西（阿拉圭那）", "zh-Hans": "巴西（阿拉瓜伊纳）" },
    "America/Argentina/Buenos_Aires": { "zh-Hant": "阿根廷（布宜諾斯艾利斯）", "zh-Hans": "阿根廷（布宜诺斯艾利斯）" },
    "America/Argentina/Catamarca": { "zh-Hant": "阿根廷（卡塔馬卡）", "zh-Hans": "阿根廷（卡塔马卡）" },
    "America/Argentina/Cordoba": { "zh-Hant": "阿根廷（哥多華）", "zh-Hans": "阿根廷（科尔多瓦）" },
    "America/Argentina/Jujuy": { "zh-Hant": "阿根廷（胡胡伊）", "zh-Hans": "阿根廷（胡胡伊）" },
    "America/Argentina/La_Rioja": { "zh-Hant": "阿根廷（拉略哈）", "zh-Hans": "阿根廷（拉里奥哈）" },
    "America/Argentina/Mendoza": { "zh-Hant": "阿根廷（門多薩）", "zh-Hans": "阿根廷（门多萨）" },
    "America/Argentina/Rio_Gallegos": { "zh-Hant": "阿根廷（里奧加耶戈斯）", "zh-Hans": "阿根廷（里奥加耶戈斯）" },
    "America/Argentina/Salta": { "zh-Hant": "阿根廷（薩爾塔）", "zh-Hans": "阿根廷（萨尔塔）" },
    "America/Argentina/San_Juan": { "zh-Hant": "阿根廷（聖胡安）", "zh-Hans": "阿根廷（圣胡安）" },
    "America/Argentina/San_Luis": { "zh-Hant": "阿根廷（聖路易）", "zh-Hans": "阿根廷（圣路易斯）" },
    "America/Argentina/Tucuman": { "zh-Hant": "阿根廷（吐庫曼）", "zh-Hans": "阿根廷（图库曼）" },
    "America/Argentina/Ushuaia": { "zh-Hant": "阿根廷（烏斯懷亞）", "zh-Hans": "阿根廷（乌斯怀亚）" },
    "America/Aruba": { "zh-Hant": "荷屬阿魯巴", "zh-Hans": "阿鲁巴" },
    "America/Asuncion": { "zh-Hant": "巴拉圭", "zh-Hans": "巴拉圭" },
    "America/Atikokan": { "zh-Hant": "加拿大（阿蒂科肯）", "zh-Hans": "加拿大（阿蒂科肯）" },
    "America/Atka": { "zh-Hant": "美國（艾達克）", "zh-Hans": "美国（埃达克）" },
    "America/Bahia": { "zh-Hant": "巴西（巴伊阿）", "zh-Hans": "巴西（巴伊亚）" },
    "America/Bahia_Banderas": { "zh-Hant": "墨西哥（巴伊亞班德拉斯）", "zh-Hans": "墨西哥（巴伊亚班德拉斯）" },
    "America/Barbados": { "zh-Hant": "巴貝多", "zh-Hans": "巴巴多斯" },
    "America/Belem": { "zh-Hant": "巴西（貝倫）", "zh-Hans": "巴西（贝伦）" },
    "America/Belize": { "zh-Hant": "貝里斯", "zh-Hans": "伯利兹" },
    "America/Blanc-Sablon": { "zh-Hant": "加拿大（白朗薩布隆）", "zh-Hans": "加拿大（布兰克萨布隆）" },
    "America/Boa_Vista": { "zh-Hant": "巴西（保維斯塔）", "zh-Hans": "巴西（博阿维斯塔）" },
    "America/Bogota": { "zh-Hant": "哥倫比亞", "zh-Hans": "哥伦比亚" },
    "America/Boise": { "zh-Hant": "美國（波夕）", "zh-Hans": "美国（博伊西）" },
    "America/Cambridge_Bay": { "zh-Hant": "加拿大（劍橋灣）", "zh-Hans": "加拿大（剑桥湾）" },
    "America/Campo_Grande": { "zh-Hant": "巴西（格蘭場）", "zh-Hans": "巴西（大坎普）" },
    "America/Cancun": { "zh-Hant": "墨西哥（坎昆）", "zh-Hans": "墨西哥（坎昆）" },
    "America/Caracas": { "zh-Hant": "委內瑞拉", "zh-Hans": "委内瑞拉" },
    "America/Cayenne": { "zh-Hant": "法屬圭亞那", "zh-Hans": "法属圭亚那" },
    "America/Cayman": { "zh-Hant": "開曼群島", "zh-Hans": "开曼群岛" },
    "America/Chicago": { "zh-Hant": "美國（芝加哥）", "zh-Hans": "美国（芝加哥）" },
    "America/Chihuahua": { "zh-Hant": "墨西哥（奇華華）", "zh-Hans": "墨西哥（奇瓦瓦）" },
    "America/Ciudad_Juarez": { "zh-Hant": "墨西哥（華雷斯）", "zh-Hans": "墨西哥（华雷斯城）" },
    "America/Coral_Harbour": { "zh-Hant": "加拿大（阿蒂科肯）", "zh-Hans": "加拿大（阿蒂科肯）" },
    "America/Costa_Rica": { "zh-Hant": "哥斯大黎加", "zh-Hans": "哥斯达黎加" },
    "America/Coyhaique": { "zh-Hant": "未知區域（Coyhaique）", "zh-Hans": "未知地区（Coyhaique）" },
    "America/Creston": { "zh-Hant": "加拿大（克雷斯頓）", "zh-Hans": "加拿大（克雷斯顿）" },
    "America/Cuiaba": { "zh-Hant": "巴西（古雅巴）", "zh-Hans": "巴西（库亚巴）" },
    "America/Curacao": { "zh-Hant": "庫拉索", "zh-Hans": "库拉索" },
    "America/Danmarkshavn": { "zh-Hant": "格陵蘭（丹馬沙文）", "zh-Hans": "格陵兰（丹马沙文）" },
    "America/Dawson": { "zh-Hant": "加拿大（道森）", "zh-Hans": "加拿大（道森）" },
    "America/Dawson_Creek": { "zh-Hant": "加拿大（道森克里克）", "zh-Hans": "加拿大（道森克里克）" },
    "America/Denver": { "zh-Hant": "美國（丹佛）", "zh-Hans": "美国（丹佛）" },
    "America/Detroit": { "zh-Hant": "美國（底特律）", "zh-Hans": "美国（底特律）" },
    "America/Dominica": { "zh-Hant": "多米尼克", "zh-Hans": "多米尼克" },
    "America/Edmonton": { "zh-Hant": "加拿大（艾德蒙吞）", "zh-Hans": "加拿大（埃德蒙顿）" },
    "America/Eirunepe": { "zh-Hant": "巴西（艾魯內佩）", "zh-Hans": "巴西（依伦尼贝）" },
    "America/El_Salvador": { "zh-Hant": "薩爾瓦多", "zh-Hans": "萨尔瓦多" },
    "America/Ensenada": { "zh-Hant": "墨西哥（提華納）", "zh-Hans": "墨西哥（蒂华纳）" },
    "America/Fort_Nelson": { "zh-Hant": "加拿大（納爾遜堡）", "zh-Hans": "加拿大（纳尔逊堡）" },
    "America/Fortaleza": { "zh-Hant": "巴西（福塔力莎）", "zh-Hans": "巴西（福塔雷萨）" },
    "America/Glace_Bay": { "zh-Hant": "加拿大（格雷斯貝）", "zh-Hans": "加拿大（格莱斯贝）" },
    "America/Goose_Bay": { "zh-Hant": "加拿大（鵝灣）", "zh-Hans": "加拿大（古斯湾）" },
    "America/Grand_Turk": { "zh-Hant": "土克斯及開科斯群島", "zh-Hans": "特克斯和凯科斯群岛" },
    "America/Grenada": { "zh-Hant": "格瑞那達", "zh-Hans": "格林纳达" },
    "America/Guadeloupe": { "zh-Hant": "瓜地洛普", "zh-Hans": "瓜德罗普" },
    "America/Guatemala": { "zh-Hant": "瓜地馬拉", "zh-Hans": "危地马拉" },
    "America/Guayaquil": { "zh-Hant": "厄瓜多（瓜亞基爾）", "zh-Hans": "厄瓜多尔（瓜亚基尔）" },
    "America/Guyana": { "zh-Hant": "蓋亞那", "zh-Hans": "圭亚那" },
    "America/Halifax": { "zh-Hant": "加拿大（哈里法克斯）", "zh-Hans": "加拿大（哈利法克斯）" },
    "America/Havana": { "zh-Hant": "古巴", "zh-Hans": "古巴" },
    "America/Hermosillo": { "zh-Hant": "墨西哥（埃莫西約）", "zh-Hans": "墨西哥（埃莫西约）" },
    "America/Indiana/Indianapolis": { "zh-Hant": "美國（印第安那波里斯）", "zh-Hans": "美国（印第安纳波利斯）" },
    "America/Indiana/Knox": { "zh-Hant": "美國（印第安那州諾克斯）", "zh-Hans": "美国（印第安纳州诺克斯）" },
    "America/Indiana/Marengo": { "zh-Hant": "美國（印第安那州馬倫哥）", "zh-Hans": "美国（印第安纳州马伦戈）" },
    "America/Indiana/Petersburg": { "zh-Hant": "美國（印第安那州彼得堡）", "zh-Hans": "美国（印第安纳州彼得斯堡）" },
    "America/Indiana/Tell_City": { "zh-Hant": "美國（印第安那州泰爾城）", "zh-Hans": "美国（印第安纳州特尔城）" },
    "America/Indiana/Vevay": { "zh-Hant": "美國（印第安那州維威）", "zh-Hans": "美国（印第安纳州维维市）" },
    "America/Indiana/Vincennes": { "zh-Hant": "美國（印第安那州溫森斯）", "zh-Hans": "美国（印第安纳州温森斯）" },
    "America/Indiana/Winamac": { "zh-Hant": "美國（印第安那州威納馬克）", "zh-Hans": "美国（印第安纳州威纳马克）" },
    "America/Inuvik": { "zh-Hant": "加拿大（伊奴維克）", "zh-Hans": "加拿大（伊努维克）" },
    "America/Iqaluit": { "zh-Hant": "加拿大（伊魁特）", "zh-Hans": "加拿大（伊魁特）" },
    "America/Jamaica": { "zh-Hant": "牙買加", "zh-Hans": "牙买加" },
    "America/Juneau": { "zh-Hant": "美國（朱諾）", "zh-Hans": "美国（朱诺）" },
    "America/Kentucky/Louisville": { "zh-Hant": "美國（路易斯維爾）", "zh-Hans": "美国（路易斯维尔）" },
    "America/Kentucky/Monticello": { "zh-Hant": "美國（肯塔基州蒙地卻羅）", "zh-Hans": "美国（肯塔基州蒙蒂塞洛）" },
    "America/Kralendijk": { "zh-Hant": "荷蘭加勒比區", "zh-Hans": "荷属加勒比区" },
    "America/La_Paz": { "zh-Hant": "玻利維亞", "zh-Hans": "玻利维亚" },
    "America/Lima": { "zh-Hant": "秘魯", "zh-Hans": "秘鲁" },
    "America/Los_Angeles": { "zh-Hant": "美國（洛杉磯）", "zh-Hans": "美国（洛杉矶）" },
    "America/Lower_Princes": { "zh-Hant": "荷屬聖馬丁", "zh-Hans": "荷属圣马丁" },
    "America/Maceio": { "zh-Hant": "巴西（馬瑟歐）", "zh-Hans": "巴西（马塞约）" },
    "America/Managua": { "zh-Hant": "尼加拉瓜", "zh-Hans": "尼加拉瓜" },
    "America/Manaus": { "zh-Hant": "巴西（瑪瑙斯）", "zh-Hans": "巴西（马瑙斯）" },
    "America/Marigot": { "zh-Hant": "法屬聖馬丁", "zh-Hans": "法属圣马丁" },
    "America/Martinique": { "zh-Hant": "馬丁尼克", "zh-Hans": "马提尼克" },
    "America/Matamoros": { "zh-Hant": "墨西哥（馬塔莫羅斯）", "zh-Hans": "墨西哥（马塔莫罗斯）" },
    "America/Mazatlan": { "zh-Hant": "墨西哥（馬薩特蘭）", "zh-Hans": "墨西哥（马萨特兰）" },
    "America/Menominee": { "zh-Hant": "美國（美諾米尼）", "zh-Hans": "美国（梅诺米尼）" },
    "America/Merida": { "zh-Hant": "墨西哥（梅里達）", "zh-Hans": "墨西哥（梅里达）" },
    "America/Metlakatla": { "zh-Hant": "美國（梅特拉卡特拉）", "zh-Hans": "美国（梅特拉卡特拉）" },
    "America/Mexico_City": { "zh-Hant": "墨西哥（墨西哥市）", "zh-Hans": "墨西哥（墨西哥城）" },
    "America/Miquelon": { "zh-Hant": "聖皮埃與密克隆群島", "zh-Hans": "圣皮埃尔和密克隆群岛" },
    "America/Moncton": { "zh-Hant": "加拿大（蒙克頓）", "zh-Hans": "加拿大（蒙克顿）" },
    "America/Monterrey": { "zh-Hant": "墨西哥（蒙特瑞）", "zh-Hans": "墨西哥（蒙特雷）" },
    "America/Montevideo": { "zh-Hant": "烏拉圭", "zh-Hans": "乌拉圭" },
    "America/Montreal": { "zh-Hant": "加拿大（多倫多）", "zh-Hans": "加拿大（多伦多）" },
    "America/Montserrat": { "zh-Hant": "蒙哲臘", "zh-Hans": "蒙特塞拉特" },
    "America/Nassau": { "zh-Hant": "巴哈馬", "zh-Hans": "巴哈马" },
    "America/New_York": { "zh-Hant": "美國（紐約）", "zh-Hans": "美国（纽约）" },
    "America/Nipigon": { "zh-Hant": "加拿大（多倫多）", "zh-Hans": "加拿大（多伦多）" },
    "America/Nome": { "zh-Hant": "美國（諾姆）", "zh-Hans": "美国（诺姆）" },
    "America/Noronha": { "zh-Hant": "巴西（諾倫哈）", "zh-Hans": "巴西（洛罗尼亚）" },
    "America/North_Dakota/Beulah": { "zh-Hant": "美國（北達科他州布由拉）", "zh-Hans": "美国（北达科他州比尤拉）" },
    "America/North_Dakota/Center": { "zh-Hant": "美國（北達科他州中心）", "zh-Hans": "美国（北达科他州申特）" },
    "America/North_Dakota/New_Salem": { "zh-Hant": "美國（北達科他州紐沙倫）", "zh-Hans": "美国（北达科他州新塞勒姆）" },
    "America/Nuuk": { "zh-Hant": "格陵蘭（努克）", "zh-Hans": "格陵兰（努克）" },
    "America/Ojinaga": { "zh-Hant": "墨西哥（奧希納加）", "zh-Hans": "墨西哥（奥希纳加）" },
    "America/Panama": { "zh-Hant": "巴拿馬", "zh-Hans": "巴拿马" },
    "America/Pangnirtung": { "zh-Hant": "加拿大（伊魁特）", "zh-Hans": "加拿大（伊魁特）" },
    "America/Paramaribo": { "zh-Hant": "蘇利南", "zh-Hans": "苏里南" },
    "America/Phoenix": { "zh-Hant": "美國（鳳凰城）", "zh-Hans": "美国（凤凰城）" },
    "America/Port-au-Prince": { "zh-Hant": "海地", "zh-Hans": "海地" },
    "America/Port_of_Spain": { "zh-Hant": "千里達及托巴哥", "zh-Hans": "特立尼达和多巴哥" },
    "America/Porto_Acre": { "zh-Hant": "巴西（里約布蘭）", "zh-Hans": "巴西（里奥布郎库）" },
    "America/Porto_Velho": { "zh-Hant": "巴西（維留港）", "zh-Hans": "巴西（波多韦柳）" },
    "America/Puerto_Rico": { "zh-Hant": "波多黎各", "zh-Hans": "波多黎各" },
    "America/Punta_Arenas": { "zh-Hant": "智利（蓬塔阿雷納斯）", "zh-Hans": "智利（蓬塔阿雷纳斯）" },
    "America/Rainy_River": { "zh-Hant": "加拿大（溫尼伯）", "zh-Hans": "加拿大（温尼伯）" },
    "America/Rankin_Inlet": { "zh-Hant": "加拿大（蘭今灣）", "zh-Hans": "加拿大（兰今湾）" },
    "America/Recife": { "zh-Hant": "巴西（雷西非）", "zh-Hans": "巴西（累西腓）" },
    "America/Regina": { "zh-Hant": "加拿大（里賈納）", "zh-Hans": "加拿大（里贾纳）" },
    "America/Resolute": { "zh-Hant": "加拿大（羅斯魯特）", "zh-Hans": "加拿大（雷索卢特）" },
    "America/Rio_Branco": { "zh-Hant": "巴西（里約布蘭）", "zh-Hans": "巴西（里奥布郎库）" },
    "America/Santa_Isabel": { "zh-Hant": "墨西哥（提華納）", "zh-Hans": "墨西哥（蒂华纳）" },
    "America/Santarem": { "zh-Hant": "巴西（聖塔倫）", "zh-Hans": "巴西（圣塔伦）" },
    "America/Santiago": { "zh-Hant": "智利（聖地牙哥）", "zh-Hans": "智利（圣地亚哥）" },
    "America/Santo_Domingo": { "zh-Hant": "多明尼加共和國", "zh-Hans": "多米尼加共和国" },
    "America/Sao_Paulo": { "zh-Hant": "巴西（聖保羅）", "zh-Hans": "巴西（圣保罗）" },
    "America/Scoresbysund": { "zh-Hant": "格陵蘭（伊托科爾托米特）", "zh-Hans": "格陵兰（斯科列斯比桑德）" },
    "America/Shiprock": { "zh-Hant": "美國（丹佛）", "zh-Hans": "美国（丹佛）" },
    "America/Sitka": { "zh-Hant": "美國（錫特卡）", "zh-Hans": "美国（锡特卡）" },
    "America/St_Barthelemy": { "zh-Hant": "聖巴瑟米", "zh-Hans": "圣巴泰勒米" },
    "America/St_Johns": { "zh-Hant": "加拿大（聖約翰）", "zh-Hans": "加拿大（圣约翰斯）" },
    "America/St_Kitts": { "zh-Hant": "聖克里斯多福及尼維斯", "zh-Hans": "圣基茨和尼维斯" },
    "America/St_Lucia": { "zh-Hant": "聖露西亞", "zh-Hans": "圣卢西亚" },
    "America/St_Thomas": { "zh-Hant": "美屬維京群島", "zh-Hans": "美属维尔京群岛" },
    "America/St_Vincent": { "zh-Hant": "聖文森及格瑞那丁", "zh-Hans": "圣文森特和格林纳丁斯" },
    "America/Swift_Current": { "zh-Hant": "加拿大（斯威夫特卡倫特）", "zh-Hans": "加拿大（斯威夫特卡伦特）" },
    "America/Tegucigalpa": { "zh-Hant": "宏都拉斯", "zh-Hans": "洪都拉斯" },
    "America/Thule": { "zh-Hant": "格陵蘭（杜里）", "zh-Hans": "格陵兰（图勒）" },
    "America/Thunder_Bay": { "zh-Hant": "加拿大（多倫多）", "zh-Hans": "加拿大（多伦多）" },
    "America/Tijuana": { "zh-Hant": "墨西哥（提華納）", "zh-Hans": "墨西哥（蒂华纳）" },
    "America/Toronto": { "zh-Hant": "加拿大（多倫多）", "zh-Hans": "加拿大（多伦多）" },
    "America/Tortola": { "zh-Hant": "英屬維京群島", "zh-Hans": "英属维尔京群岛" },
    "America/Vancouver": { "zh-Hant": "加拿大（溫哥華）", "zh-Hans": "加拿大（温哥华）" },
    "America/Virgin": { "zh-Hant": "美屬維京群島", "zh-Hans": "美属维尔京群岛" },
    "America/Whitehorse": { "zh-Hant": "加拿大（懷特霍斯）", "zh-Hans": "加拿大（怀特霍斯）" },
    "America/Winnipeg": { "zh-Hant": "加拿大（溫尼伯）", "zh-Hans": "加拿大（温尼伯）" },
    "America/Yakutat": { "zh-Hant": "美國（雅庫塔）", "zh-Hans": "美国（亚库塔特）" },
    "America/Yellowknife": { "zh-Hant": "加拿大（艾德蒙吞）", "zh-Hans": "加拿大（埃德蒙顿）" },
    "Antarctica/Casey": { "zh-Hant": "南極洲（凱西）", "zh-Hans": "南极洲（卡塞）" },
    "Antarctica/Davis": { "zh-Hant": "南極洲（戴維斯）", "zh-Hans": "南极洲（戴维斯）" },
    "Antarctica/DumontDUrville": { "zh-Hant": "南極洲（杜蒙杜比爾）", "zh-Hans": "南极洲（迪蒙·迪维尔）" },
    "Antarctica/Macquarie": { "zh-Hant": "澳洲（麥覺理）", "zh-Hans": "澳大利亚（麦格理）" },
    "Antarctica/Mawson": { "zh-Hant": "南極洲（莫森）", "zh-Hans": "南极洲（莫森）" },
    "Antarctica/McMurdo": { "zh-Hant": "南極洲（麥克默多）", "zh-Hans": "南极洲（麦克默多）" },
    "Antarctica/Palmer": { "zh-Hant": "南極洲（帕麥）", "zh-Hans": "南极洲（帕尔默）" },
    "Antarctica/Rothera": { "zh-Hant": "南極洲（羅瑟拉）", "zh-Hans": "南极洲（罗瑟拉）" },
    "Antarctica/Syowa": { "zh-Hant": "南極洲（昭和基地）", "zh-Hans": "南极洲（昭和）" },
    "Antarctica/Troll": { "zh-Hant": "世界（綽爾）", "zh-Hans": "世界（特罗尔）" },
    "Antarctica/Vostok": { "zh-Hant": "南極洲（沃斯托克）", "zh-Hans": "南极洲（沃斯托克）" },
    "Arctic/Longyearbyen": { "zh-Hant": "挪威屬斯瓦巴及尖棉", "zh-Hans": "斯瓦尔巴和扬马延" },
    "Asia/Aden": { "zh-Hant": "葉門", "zh-Hans": "也门" },
    "Asia/Almaty": { "zh-Hant": "哈薩克（阿拉木圖）", "zh-Hans": "哈萨克斯坦（阿拉木图）" },
    "Asia/Amman": { "zh-Hant": "約旦", "zh-Hans": "约旦" },
    "Asia/Anadyr": { "zh-Hant": "俄羅斯（阿那底）", "zh-Hans": "俄罗斯（阿纳德尔）" },
    "Asia/Aqtau": { "zh-Hant": "哈薩克（阿克套）", "zh-Hans": "哈萨克斯坦（阿克套）" },
    "Asia/Aqtobe": { "zh-Hant": "哈薩克（阿克托比）", "zh-Hans": "哈萨克斯坦（阿克托别）" },
    "Asia/Ashgabat": { "zh-Hant": "土庫曼", "zh-Hans": "土库曼斯坦" },
    "Asia/Atyrau": { "zh-Hant": "哈薩克（阿特勞）", "zh-Hans": "哈萨克斯坦（阿特劳）" },
    "Asia/Baghdad": { "zh-Hant": "伊拉克", "zh-Hans": "伊拉克" },
    "Asia/Bahrain": { "zh-Hant": "巴林", "zh-Hans": "巴林" },
    "Asia/Baku": { "zh-Hant": "亞塞拜然", "zh-Hans": "阿塞拜疆" },
    "Asia/Bangkok": { "zh-Hant": "泰國", "zh-Hans": "泰国" },
    "Asia/Barnaul": { "zh-Hant": "俄羅斯（巴爾瑙爾）", "zh-Hans": "俄罗斯（巴尔瑙尔）" },
    "Asia/Beirut": { "zh-Hant": "黎巴嫩", "zh-Hans": "黎巴嫩" },
    "Asia/Bishkek": { "zh-Hant": "吉爾吉斯", "zh-Hans": "吉尔吉斯斯坦" },
    "Asia/Brunei": { "zh-Hant": "汶萊", "zh-Hans": "文莱" },
    "Asia/Chita": { "zh-Hant": "俄羅斯（赤塔）", "zh-Hans": "俄罗斯（赤塔）" },
    "Asia/Chongqing": { "zh-Hant": "中國（上海）", "zh-Hans": "中国（上海）" },
    "Asia/Colombo": { "zh-Hant": "斯里蘭卡", "zh-Hans": "斯里兰卡" },
    "Asia/Damascus": { "zh-Hant": "敘利亞", "zh-Hans": "叙利亚" },
    "Asia/Dhaka": { "zh-Hant": "孟加拉", "zh-Hans": "孟加拉国" },
    "Asia/Dili": { "zh-Hant": "東帝汶", "zh-Hans": "东帝汶" },
    "Asia/Dubai": { "zh-Hant": "阿拉伯聯合大公國", "zh-Hans": "阿拉伯联合酋长国" },
    "Asia/Dushanbe": { "zh-Hant": "塔吉克", "zh-Hans": "塔吉克斯坦" },
    "Asia/Famagusta": { "zh-Hant": "賽普勒斯（法馬古斯塔）", "zh-Hans": "塞浦路斯（法马古斯塔）" },
    "Asia/Gaza": { "zh-Hant": "巴勒斯坦自治區（加薩）", "zh-Hans": "巴勒斯坦领土（加沙）" },
    "Asia/Harbin": { "zh-Hant": "中國（上海）", "zh-Hans": "中国（上海）" },
    "Asia/Hebron": { "zh-Hant": "巴勒斯坦自治區（赫布隆）", "zh-Hans": "巴勒斯坦领土（希伯伦）" },
    "Asia/Ho_Chi_Minh": { "zh-Hant": "越南", "zh-Hans": "越南" },
    "Asia/Hong_Kong": { "zh-Hant": "中國香港特別行政區", "zh-Hans": "中国香港特别行政区" },
    "Asia/Hovd": { "zh-Hant": "蒙古（科布多）", "zh-Hans": "蒙古（科布多）" },
    "Asia/Irkutsk": { "zh-Hant": "俄羅斯（伊爾庫次克）", "zh-Hans": "俄罗斯（伊尔库茨克）" },
    "Asia/Istanbul": { "zh-Hant": "土耳其", "zh-Hans": "土耳其" },
    "Asia/Jakarta": { "zh-Hant": "印尼（雅加達）", "zh-Hans": "印度尼西亚（雅加达）" },
    "Asia/Jayapura": { "zh-Hant": "印尼（加亞布拉）", "zh-Hans": "印度尼西亚（查亚普拉）" },
    "Asia/Jerusalem": { "zh-Hant": "以色列", "zh-Hans": "以色列" },
    "Asia/Kabul": { "zh-Hant": "阿富汗", "zh-Hans": "阿富汗" },
    "Asia/Kamchatka": { "zh-Hant": "俄羅斯（堪察加）", "zh-Hans": "俄罗斯（堪察加）" },
    "Asia/Karachi": { "zh-Hant": "巴基斯坦", "zh-Hans": "巴基斯坦" },
    "Asia/Kashgar": { "zh-Hant": "中國（烏魯木齊）", "zh-Hans": "中国（乌鲁木齐）" },
    "Asia/Kathmandu": { "zh-Hant": "尼泊爾", "zh-Hans": "尼泊尔" },
    "Asia/Khandyga": { "zh-Hant": "俄羅斯（堪地加）", "zh-Hans": "俄罗斯（汉德加）" },
    "Asia/Kolkata": { "zh-Hant": "印度", "zh-Hans": "印度" },
    "Asia/Krasnoyarsk": { "zh-Hant": "俄羅斯（克拉斯諾亞爾斯克）", "zh-Hans": "俄罗斯（克拉斯诺亚尔斯克）" },
    "Asia/Kuala_Lumpur": { "zh-Hant": "馬來西亞（吉隆坡）", "zh-Hans": "马来西亚（吉隆坡）" },
    "Asia/Kuching": { "zh-Hant": "馬來西亞（古晉）", "zh-Hans": "马来西亚（古晋）" },
    "Asia/Kuwait": { "zh-Hant": "科威特", "zh-Hans": "科威特" },
    "Asia/Macau": { "zh-Hant": "中國澳門特別行政區", "zh-Hans": "中国澳门特别行政区" },
    "Asia/Magadan": { "zh-Hant": "俄羅斯（馬加丹）", "zh-Hans": "俄罗斯（马加丹）" },
    "Asia/Makassar": { "zh-Hant": "印尼（馬卡沙爾）", "zh-Hans": "印度尼西亚（望加锡）" },
    "Asia/Manila": { "zh-Hant": "菲律賓", "zh-Hans": "菲律宾" },
    "Asia/Muscat": { "zh-Hant": "阿曼", "zh-Hans": "阿曼" },
    "Asia/Nicosia": { "zh-Hant": "賽普勒斯（尼古西亞）", "zh-Hans": "塞浦路斯（尼科西亚）" },
    "Asia/Novokuznetsk": { "zh-Hant": "俄羅斯（新庫茲涅茨克）", "zh-Hans": "俄罗斯（新库兹涅茨克）" },
    "Asia/Novosibirsk": { "zh-Hant": "俄羅斯（新西伯利亞）", "zh-Hans": "俄罗斯（新西伯利亚）" },
    "Asia/Omsk": { "zh-Hant": "俄羅斯（鄂木斯克）", "zh-Hans": "俄罗斯（鄂木斯克）" },
    "Asia/Oral": { "zh-Hant": "哈薩克（烏拉爾）", "zh-Hans": "哈萨克斯坦（乌拉尔）" },
    "Asia/Phnom_Penh": { "zh-Hant": "柬埔寨", "zh-Hans": "柬埔寨" },
    "Asia/Pontianak": { "zh-Hant": "印尼（坤甸）", "zh-Hans": "印度尼西亚（坤甸）" },
    "Asia/Pyongyang": { "zh-Hant": "北韓", "zh-Hans": "朝鲜" },
    "Asia/Qatar": { "zh-Hant": "卡達", "zh-Hans": "卡塔尔" },
    "Asia/Qostanay": { "zh-Hant": "哈薩克（庫斯塔奈）", "zh-Hans": "哈萨克斯坦（库斯塔奈）" },
    "Asia/Qyzylorda": { "zh-Hant": "哈薩克（克孜勒奧爾達）", "zh-Hans": "哈萨克斯坦（克孜洛尔达）" },
    "Asia/Riyadh": { "zh-Hant": "沙烏地阿拉伯", "zh-Hans": "沙特阿拉伯" },
    "Asia/Sakhalin": { "zh-Hant": "俄羅斯（庫頁島）", "zh-Hans": "俄罗斯（萨哈林）" },
    "Asia/Samarkand": { "zh-Hant": "烏茲別克（撒馬爾罕）", "zh-Hans": "乌兹别克斯坦（撒马尔罕）" },
    "Asia/Seoul": { "zh-Hant": "南韓", "zh-Hans": "韩国" },
    "Asia/Shanghai": { "zh-Hant": "中國（上海）", "zh-Hans": "中国（上海）" },
    "Asia/Singapore": { "zh-Hant": "新加坡", "zh-Hans": "新加坡" },
    "Asia/Srednekolymsk": { "zh-Hant": "俄羅斯（中科雷姆斯克）", "zh-Hans": "俄罗斯（中科雷姆斯克）" },
    "Asia/Taipei": { "zh-Hant": "台灣", "zh-Hans": "台湾" },
    "Asia/Tashkent": { "zh-Hant": "烏茲別克（塔什干）", "zh-Hans": "乌兹别克斯坦（塔什干）" },
    "Asia/Tbilisi": { "zh-Hant": "喬治亞", "zh-Hans": "格鲁吉亚" },
    "Asia/Tehran": { "zh-Hant": "伊朗", "zh-Hans": "伊朗" },
    "Asia/Tel_Aviv": { "zh-Hant": "以色列", "zh-Hans": "以色列" },
    "Asia/Thimphu": { "zh-Hant": "不丹", "zh-Hans": "不丹" },
    "Asia/Tokyo": { "zh-Hant": "日本", "zh-Hans": "日本" },
    "Asia/Tomsk": { "zh-Hant": "俄羅斯（托木斯克）", "zh-Hans": "俄罗斯（托木斯克）" },
    "Asia/Ulaanbaatar": { "zh-Hant": "蒙古（烏蘭巴托）", "zh-Hans": "蒙古（乌兰巴托）" },
    "Asia/Urumqi": { "zh-Hant": "中國（烏魯木齊）", "zh-Hans": "中国（乌鲁木齐）" },
    "Asia/Ust-Nera": { "zh-Hant": "俄羅斯（烏斯內拉）", "zh-Hans": "俄罗斯（乌斯内拉）" },
    "Asia/Vientiane": { "zh-Hant": "寮國", "zh-Hans": "老挝" },
    "Asia/Vladivostok": { "zh-Hant": "俄羅斯（海參崴）", "zh-Hans": "俄罗斯（符拉迪沃斯托克）" },
    "Asia/Yakutsk": { "zh-Hant": "俄羅斯（雅庫次克）", "zh-Hans": "俄罗斯（雅库茨克）" },
    "Asia/Yangon": { "zh-Hant": "緬甸", "zh-Hans": "缅甸" },
    "Asia/Yekaterinburg": { "zh-Hant": "俄羅斯（葉卡捷林堡）", "zh-Hans": "俄罗斯（叶卡捷琳堡）" },
    "Asia/Yerevan": { "zh-Hant": "亞美尼亞", "zh-Hans": "亚美尼亚" },
    "Atlantic/Azores": { "zh-Hant": "葡萄牙（亞速爾群島）", "zh-Hans": "葡萄牙（亚速尔群岛）" },
    "Atlantic/Bermuda": { "zh-Hant": "百慕達", "zh-Hans": "百慕大" },
    "Atlantic/Canary": { "zh-Hant": "西班牙（加納利）", "zh-Hans": "西班牙（加那利）" },
    "Atlantic/Cape_Verde": { "zh-Hant": "維德角", "zh-Hans": "佛得角" },
    "Atlantic/Faroe": { "zh-Hant": "法羅群島", "zh-Hans": "法罗群岛" },
    "Atlantic/Jan_Mayen": { "zh-Hant": "挪威屬斯瓦巴及尖棉", "zh-Hans": "斯瓦尔巴和扬马延" },
    "Atlantic/Madeira": { "zh-Hant": "葡萄牙（馬得拉群島）", "zh-Hans": "葡萄牙（马德拉）" },
    "Atlantic/Reykjavik": { "zh-Hant": "冰島", "zh-Hans": "冰岛" },
    "Atlantic/South_Georgia": { "zh-Hant": "南喬治亞與南三明治群島", "zh-Hans": "南乔治亚和南桑威奇群岛" },
    "Atlantic/St_Helena": { "zh-Hant": "聖赫勒拿島", "zh-Hans": "圣赫勒拿" },
    "Atlantic/Stanley": { "zh-Hant": "福克蘭群島", "zh-Hans": "福克兰群岛" },
    "Australia/Adelaide": { "zh-Hant": "澳洲（阿得雷德）", "zh-Hans": "澳大利亚（阿德莱德）" },
    "Australia/Brisbane": { "zh-Hant": "澳洲（布利斯班）", "zh-Hans": "澳大利亚（布里斯班）" },
    "Australia/Broken_Hill": { "zh-Hant": "澳洲（布羅肯希爾）", "zh-Hans": "澳大利亚（布罗肯希尔）" },
    "Australia/Canberra": { "zh-Hant": "澳洲（雪梨）", "zh-Hans": "澳大利亚（悉尼）" },
    "Australia/Currie": { "zh-Hant": "澳洲（荷巴特）", "zh-Hans": "澳大利亚（霍巴特）" },
    "Australia/Darwin": { "zh-Hant": "澳洲（達爾文）", "zh-Hans": "澳大利亚（达尔文）" },
    "Australia/Eucla": { "zh-Hant": "澳洲（尤克拉）", "zh-Hans": "澳大利亚（尤克拉）" },
    "Australia/Hobart": { "zh-Hant": "澳洲（荷巴特）", "zh-Hans": "澳大利亚（霍巴特）" },
    "Australia/Lindeman": { "zh-Hant": "澳洲（林德曼）", "zh-Hans": "澳大利亚（林德曼）" },
    "Australia/Lord_Howe": { "zh-Hant": "澳洲（豪勳爵島）", "zh-Hans": "澳大利亚（豪勋爵岛）" },
    "Australia/Melbourne": { "zh-Hant": "澳洲（墨爾本）", "zh-Hans": "澳大利亚（墨尔本）" },
    "Australia/Perth": { "zh-Hant": "澳洲（伯斯）", "zh-Hans": "澳大利亚（珀斯）" },
    "Australia/Sydney": { "zh-Hant": "澳洲（雪梨）", "zh-Hans": "澳大利亚（悉尼）" },
    "Australia/Yancowinna": { "zh-Hant": "澳洲（布羅肯希爾）", "zh-Hans": "澳大利亚（布罗肯希尔）" },
    "Europe/Amsterdam": { "zh-Hant": "荷蘭", "zh-Hans": "荷兰" },
    "Europe/Andorra": { "zh-Hant": "安道爾", "zh-Hans": "安道尔" },
    "Europe/Astrakhan": { "zh-Hant": "俄羅斯（阿斯特拉罕）", "zh-Hans": "俄罗斯（阿斯特拉罕）" },
    "Europe/Athens": { "zh-Hant": "希臘", "zh-Hans": "希腊" },
    "Europe/Belfast": { "zh-Hant": "英國", "zh-Hans": "英国" },
    "Europe/Belgrade": { "zh-Hant": "塞爾維亞", "zh-Hans": "塞尔维亚" },
    "Europe/Berlin": { "zh-Hant": "德國（柏林）", "zh-Hans": "德国（柏林）" },
    "Europe/Bratislava": { "zh-Hant": "斯洛伐克", "zh-Hans": "斯洛伐克" },
    "Europe/Brussels": { "zh-Hant": "比利時", "zh-Hans": "比利时" },
    "Europe/Bucharest": { "zh-Hant": "羅馬尼亞", "zh-Hans": "罗马尼亚" },
    "Europe/Budapest": { "zh-Hant": "匈牙利", "zh-Hans": "匈牙利" },
    "Europe/Busingen": { "zh-Hant": "德國（布辛根）", "zh-Hans": "德国（布辛根）" },
    "Europe/Chisinau": { "zh-Hant": "摩爾多瓦", "zh-Hans": "摩尔多瓦" },
    "Europe/Copenhagen": { "zh-Hant": "丹麥", "zh-Hans": "丹麦" },
    "Europe/Dublin": { "zh-Hant": "愛爾蘭", "zh-Hans": "爱尔兰" },
    "Europe/Gibraltar": { "zh-Hant": "直布羅陀", "zh-Hans": "直布罗陀" },
    "Europe/Guernsey": { "zh-Hant": "根息", "zh-Hans": "根西岛" },
    "Europe/Helsinki": { "zh-Hant": "芬蘭", "zh-Hans": "芬兰" },
    "Europe/Isle_of_Man": { "zh-Hant": "曼島", "zh-Hans": "马恩岛" },
    "Europe/Istanbul": { "zh-Hant": "土耳其", "zh-Hans": "土耳其" },
    "Europe/Jersey": { "zh-Hant": "澤西島", "zh-Hans": "泽西岛" },
    "Europe/Kaliningrad": { "zh-Hant": "俄羅斯（加里寧格勒）", "zh-Hans": "俄罗斯（加里宁格勒）" },
    "Europe/Kirov": { "zh-Hant": "俄羅斯（基洛夫）", "zh-Hans": "俄罗斯（基洛夫）" },
    "Europe/Kyiv": { "zh-Hant": "烏克蘭（基輔）", "zh-Hans": "乌克兰（基辅）" },
    "Europe/Lisbon": { "zh-Hant": "葡萄牙（里斯本）", "zh-Hans": "葡萄牙（里斯本）" },
    "Europe/Ljubljana": { "zh-Hant": "斯洛維尼亞", "zh-Hans": "斯洛文尼亚" },
    "Europe/London": { "zh-Hant": "英國", "zh-Hans": "英国" },
    "Europe/Luxembourg": { "zh-Hant": "盧森堡", "zh-Hans": "卢森堡" },
    "Europe/Madrid": { "zh-Hant": "西班牙（馬德里）", "zh-Hans": "西班牙（马德里）" },
    "Europe/Malta": { "zh-Hant": "馬爾他", "zh-Hans": "马耳他" },
    "Europe/Mariehamn": { "zh-Hant": "奧蘭群島", "zh-Hans": "奥兰群岛" },
    "Europe/Minsk": { "zh-Hant": "白俄羅斯", "zh-Hans": "白俄罗斯" },
    "Europe/Monaco": { "zh-Hant": "摩納哥", "zh-Hans": "摩纳哥" },
    "Europe/Moscow": { "zh-Hant": "俄羅斯（莫斯科）", "zh-Hans": "俄罗斯（莫斯科）" },
    "Europe/Nicosia": { "zh-Hant": "賽普勒斯（尼古西亞）", "zh-Hans": "塞浦路斯（尼科西亚）" },
    "Europe/Oslo": { "zh-Hant": "挪威", "zh-Hans": "挪威" },
    "Europe/Paris": { "zh-Hant": "法國", "zh-Hans": "法国" },
    "Europe/Podgorica": { "zh-Hant": "蒙特內哥羅", "zh-Hans": "黑山" },
    "Europe/Prague": { "zh-Hant": "捷克", "zh-Hans": "捷克" },
    "Europe/Riga": { "zh-Hant": "拉脫維亞", "zh-Hans": "拉脱维亚" },
    "Europe/Rome": { "zh-Hant": "義大利", "zh-Hans": "意大利" },
    "Europe/Samara": { "zh-Hant": "俄羅斯（沙馬拉）", "zh-Hans": "俄罗斯（萨马拉）" },
    "Europe/San_Marino": { "zh-Hant": "聖馬利諾", "zh-Hans": "圣马力诺" },
    "Europe/Sarajevo": { "zh-Hant": "波士尼亞與赫塞哥維納", "zh-Hans": "波斯尼亚和黑塞哥维那" },
    "Europe/Saratov": { "zh-Hant": "俄羅斯（薩拉托夫）", "zh-Hans": "俄罗斯（萨拉托夫）" },
    "Europe/Simferopol": { "zh-Hant": "烏克蘭（辛非洛浦）", "zh-Hans": "乌克兰（辛菲罗波尔）" },
    "Europe/Skopje": { "zh-Hant": "北馬其頓", "zh-Hans": "北马其顿" },
    "Europe/Sofia": { "zh-Hant": "保加利亞", "zh-Hans": "保加利亚" },
    "Europe/Stockholm": { "zh-Hant": "瑞典", "zh-Hans": "瑞典" },
    "Europe/Tallinn": { "zh-Hant": "愛沙尼亞", "zh-Hans": "爱沙尼亚" },
    "Europe/Tirane": { "zh-Hant": "阿爾巴尼亞", "zh-Hans": "阿尔巴尼亚" },
    "Europe/Tiraspol": { "zh-Hant": "摩爾多瓦", "zh-Hans": "摩尔多瓦" },
    "Europe/Ulyanovsk": { "zh-Hant": "俄羅斯（烏里揚諾夫斯克）", "zh-Hans": "俄罗斯（乌里扬诺夫斯克）" },
    "Europe/Vaduz": { "zh-Hant": "列支敦斯登", "zh-Hans": "列支敦士登" },
    "Europe/Vatican": { "zh-Hant": "梵蒂岡", "zh-Hans": "梵蒂冈" },
    "Europe/Vienna": { "zh-Hant": "奧地利", "zh-Hans": "奥地利" },
    "Europe/Vilnius": { "zh-Hant": "立陶宛", "zh-Hans": "立陶宛" },
    "Europe/Volgograd": { "zh-Hant": "俄羅斯（伏爾加格勒）", "zh-Hans": "俄罗斯（伏尔加格勒）" },
    "Europe/Warsaw": { "zh-Hant": "波蘭", "zh-Hans": "波兰" },
    "Europe/Zagreb": { "zh-Hant": "克羅埃西亞", "zh-Hans": "克罗地亚" },
    "Europe/Zurich": { "zh-Hant": "瑞士", "zh-Hans": "瑞士" },
    "Indian/Antananarivo": { "zh-Hant": "馬達加斯加", "zh-Hans": "马达加斯加" },
    "Indian/Chagos": { "zh-Hant": "英屬印度洋領地", "zh-Hans": "英属印度洋领地" },
    "Indian/Christmas": { "zh-Hant": "聖誕島", "zh-Hans": "圣诞岛" },
    "Indian/Cocos": { "zh-Hant": "科克斯（基靈）群島", "zh-Hans": "科科斯（基林）群岛" },
    "Indian/Comoro": { "zh-Hant": "葛摩", "zh-Hans": "科摩罗" },
    "Indian/Kerguelen": { "zh-Hant": "法屬南部屬地", "zh-Hans": "法属南部领地" },
    "Indian/Mahe": { "zh-Hant": "塞席爾", "zh-Hans": "塞舌尔" },
    "Indian/Maldives": { "zh-Hant": "馬爾地夫", "zh-Hans": "马尔代夫" },
    "Indian/Mauritius": { "zh-Hant": "模里西斯", "zh-Hans": "毛里求斯" },
    "Indian/Mayotte": { "zh-Hant": "馬約特島", "zh-Hans": "马约特" },
    "Indian/Reunion": { "zh-Hant": "留尼旺", "zh-Hans": "留尼汪" },
    "Pacific/Apia": { "zh-Hant": "薩摩亞", "zh-Hans": "萨摩亚" },
    "Pacific/Auckland": { "zh-Hant": "紐西蘭（奧克蘭）", "zh-Hans": "新西兰（奥克兰）" },
    "Pacific/Bougainville": { "zh-Hant": "巴布亞紐幾內亞（布干維爾）", "zh-Hans": "巴布亚新几内亚（布干维尔）" },
    "Pacific/Chatham": { "zh-Hant": "紐西蘭（查坦）", "zh-Hans": "新西兰（查塔姆）" },
    "Pacific/Chuuk": { "zh-Hant": "密克羅尼西亞（楚克）", "zh-Hans": "密克罗尼西亚（特鲁克群岛）" },
    "Pacific/Easter": { "zh-Hant": "智利（復活島）", "zh-Hans": "智利（复活节岛）" },
    "Pacific/Efate": { "zh-Hant": "萬那杜", "zh-Hans": "瓦努阿图" },
    "Pacific/Fakaofo": { "zh-Hant": "托克勞群島", "zh-Hans": "托克劳" },
    "Pacific/Fiji": { "zh-Hant": "斐濟", "zh-Hans": "斐济" },
    "Pacific/Funafuti": { "zh-Hant": "吐瓦魯", "zh-Hans": "图瓦卢" },
    "Pacific/Galapagos": { "zh-Hant": "厄瓜多（加拉巴哥群島）", "zh-Hans": "厄瓜多尔（科隆群岛）" },
    "Pacific/Gambier": { "zh-Hant": "法屬玻里尼西亞（甘比爾群島）", "zh-Hans": "法属波利尼西亚（甘比尔）" },
    "Pacific/Guadalcanal": { "zh-Hant": "索羅門群島", "zh-Hans": "所罗门群岛" },
    "Pacific/Guam": { "zh-Hant": "關島", "zh-Hans": "关岛" },
    "Pacific/Honolulu": { "zh-Hant": "美國（檀香山）", "zh-Hans": "美国（檀香山）" },
    "Pacific/Johnston": { "zh-Hant": "美國（檀香山）", "zh-Hans": "美国（檀香山）" },
    "Pacific/Kanton": { "zh-Hant": "吉里巴斯（恩得伯理島）", "zh-Hans": "基里巴斯（恩德伯里）" },
    "Pacific/Kiritimati": { "zh-Hant": "吉里巴斯（基里地馬地島）", "zh-Hans": "基里巴斯（基里地马地岛）" },
    "Pacific/Kosrae": { "zh-Hant": "密克羅尼西亞（科斯瑞）", "zh-Hans": "密克罗尼西亚（库赛埃）" },
    "Pacific/Kwajalein": { "zh-Hant": "馬紹爾群島（瓜加林島）", "zh-Hans": "马绍尔群岛（夸贾林）" },
    "Pacific/Majuro": { "zh-Hant": "馬紹爾群島（馬朱諾）", "zh-Hans": "马绍尔群岛（马朱罗）" },
    "Pacific/Marquesas": { "zh-Hant": "法屬玻里尼西亞（馬可薩斯島）", "zh-Hans": "法属波利尼西亚（马克萨斯）" },
    "Pacific/Midway": { "zh-Hant": "美國本土外小島嶼（中途島）", "zh-Hans": "美国本土外小岛屿（中途岛）" },
    "Pacific/Nauru": { "zh-Hant": "諾魯", "zh-Hans": "瑙鲁" },
    "Pacific/Niue": { "zh-Hant": "紐埃島", "zh-Hans": "纽埃" },
    "Pacific/Norfolk": { "zh-Hant": "諾福克島", "zh-Hans": "诺福克岛" },
    "Pacific/Noumea": { "zh-Hant": "新喀里多尼亞", "zh-Hans": "新喀里多尼亚" },
    "Pacific/Pago_Pago": { "zh-Hant": "美屬薩摩亞", "zh-Hans": "美属萨摩亚" },
    "Pacific/Palau": { "zh-Hant": "帛琉", "zh-Hans": "帕劳" },
    "Pacific/Pitcairn": { "zh-Hant": "皮特肯群島", "zh-Hans": "皮特凯恩群岛" },
    "Pacific/Pohnpei": { "zh-Hant": "密克羅尼西亞（波納佩）", "zh-Hans": "密克罗尼西亚（波纳佩岛）" },
    "Pacific/Port_Moresby": { "zh-Hant": "巴布亞紐幾內亞（莫士比港）", "zh-Hans": "巴布亚新几内亚（莫尔兹比港）" },
    "Pacific/Rarotonga": { "zh-Hant": "庫克群島", "zh-Hans": "库克群岛" },
    "Pacific/Saipan": { "zh-Hant": "北馬利安納群島", "zh-Hans": "北马里亚纳群岛" },
    "Pacific/Samoa": { "zh-Hant": "美屬薩摩亞", "zh-Hans": "美属萨摩亚" },
    "Pacific/Tahiti": { "zh-Hant": "法屬玻里尼西亞（大溪地）", "zh-Hans": "法属波利尼西亚（塔希提）" },
    "Pacific/Tarawa": { "zh-Hant": "吉里巴斯（塔拉瓦）", "zh-Hans": "基里巴斯（塔拉瓦）" },
    "Pacific/Tongatapu": { "zh-Hant": "東加", "zh-Hans": "汤加" },
    "Pacific/Wake": { "zh-Hant": "美國本土外小島嶼（威克）", "zh-Hans": "美国本土外小岛屿（威克）" },
    "Pacific/Wallis": { "zh-Hant": "瓦利斯群島和富圖那群島", "zh-Hans": "瓦利斯和富图纳" },
    "Pacific/Yap": { "zh-Hant": "密克羅尼西亞（楚克）", "zh-Hans": "密克罗尼西亚（特鲁克群岛）" },
    "Africa/Asmera": { "zh-Hant": "厄利垂亞", "zh-Hans": "厄立特里亚" },
    "America/Buenos_Aires": { "zh-Hant": "阿根廷（布宜諾斯艾利斯）", "zh-Hans": "阿根廷（布宜诺斯艾利斯）" },
    "America/Catamarca": { "zh-Hant": "阿根廷（卡塔馬卡）", "zh-Hans": "阿根廷（卡塔马卡）" },
    "America/Cordoba": { "zh-Hant": "阿根廷（哥多華）", "zh-Hans": "阿根廷（科尔多瓦）" },
    "America/Godthab": { "zh-Hant": "格陵蘭（努克）", "zh-Hans": "格陵兰（努克）" },
    "America/Indianapolis": { "zh-Hant": "美國（印第安那波里斯）", "zh-Hans": "美国（印第安纳波利斯）" },
    "America/Jujuy": { "zh-Hant": "阿根廷（胡胡伊）", "zh-Hans": "阿根廷（胡胡伊）" },
    "America/Louisville": { "zh-Hant": "美國（路易斯維爾）", "zh-Hans": "美国（路易斯维尔）" },
    "America/Mendoza": { "zh-Hant": "阿根廷（門多薩）", "zh-Hans": "阿根廷（门多萨）" },
    "Asia/Calcutta": { "zh-Hant": "印度（加爾各答）", "zh-Hans": "印度（加尔各答）" },
    "Asia/Katmandu": { "zh-Hant": "尼泊爾（加德滿都）", "zh-Hans": "尼泊尔（加德满都）" },
    "Asia/Rangoon": { "zh-Hant": "緬甸（仰光）", "zh-Hans": "缅甸（仰光）" },
    "Asia/Saigon": { "zh-Hant": "越南（胡志明市）", "zh-Hans": "越南（胡志明市）" },
    "Atlantic/Faeroe": { "zh-Hant": "法羅群島", "zh-Hans": "法罗群岛" },
    "Europe/Kiev": { "zh-Hant": "烏克蘭（基輔）", "zh-Hans": "乌克兰（基辅）" },
    "Pacific/Enderbury": { "zh-Hant": "吉里巴斯（恩得伯理島）", "zh-Hans": "基里巴斯（恩德伯里）" },
    "Pacific/Ponape": { "zh-Hant": "密克羅尼西亞（波納佩）", "zh-Hans": "密克罗尼西亚（波纳佩岛）" },
    "Pacific/Truk": { "zh-Hant": "密克羅尼西亞（楚克）", "zh-Hans": "密克罗尼西亚（特鲁克群岛）" },
};
